import webUtils from '../../../../utils/webUtils';
import React from 'react';
import Parser from 'react-html-parser';
import _get from 'lodash/get';
import _set from 'lodash/set';
import _isEmpty from 'lodash/isEmpty';
import HalfBanner from './half/async';
import FullBanner from './full/async';
import HalfSingleCtaBanner from './halfsinglecta/async';
import FullSingleCtaBanner from './fullsinglecta/async';
import {convertLink} from '../../../../pages/business/blog/post/universalShortLinksMap';
import useDeadLinkLists from '../../../hooks/useDeadLinkLists';

export default function SectionTopBannerB2C({
  width,
  content,
  addBannerBorderMb,
}) {
  const {deadLinkLists, loading} = useDeadLinkLists();
  const isDevice = width <= 1024;

  const layout = _get(content, 'layoutType');
  const imageCTA = _get(content, 'imageCTA', []);
  const mobileSingleCTA = _get(content, 'mobileSingleCTA', []);
  const desktopAppLogoUrl = webUtils.normalizeImageUrl(_get(content, 'appLogo.data.attributes.url'));
  const mobileAppLogoUrl = webUtils.normalizeImageUrl(_get(content, 'mobileAppLogo.data.attributes.url'));

  const title = Parser(_get(content, 'title'));
  const description = Parser(_get(content, 'description'), {
    transform: htmlParserTransform,
  });

  const dtAspectRatio = getAspectRatio('backgroundDesktop');
  const mbAspectRatio = getAspectRatio('backgroundMobile');
  const dtIconAspectRatio = getAspectRatio('appLogo');

  function getAspectRatio(path) {
    const width = _get(content, `${path}.data.attributes.width`);
    const height = _get(content, `${path}.data.attributes.height`);
    return width / height;
  }

  function getUrlByWidth(key, breakpoint = 600) {
    const path = width > breakpoint ? `${key}Desktop` : `${key}Mobile`;
    return webUtils.normalizeImageUrl(_get(content, `${path}.data.attributes.url`));
  }

  function htmlParserTransform(node) {
    if (node.name === 'a') {
      const link = _get(node, 'attribs.href');
      const isDeadLink = deadLinkLists.some(d => link && link.includes(d));
      if (isDeadLink) {
        if (_get(node, 'attribs.href')) delete node.attribs.href;
        if (_get(node, 'attribs.target')) delete node.attribs.target;
        if (_get(node, 'attribs.rel')) delete node.attribs.rel;
        return;
      }
      _set(node, 'attribs.href', convertLink(link));
    }
  }

  function appList() {
    if (_isEmpty(_get(content, 'iconButtons'))) return [];
    return _get(content, 'iconButtons').map(s => {
      return {
        name: s.instruction,
        icon: webUtils.normalizeImageUrl(_get(s, 'Image.data.attributes.url')),
        text: s.instruction,
        link: s.ctaLink,
        newTab: s.newTab,
      };
    });
  }

  if (loading) return <div />;
  if (layout === 'Half') {
    return (
      <HalfBanner
        width={width}
        isDevice={isDevice}
        imageCTA={imageCTA}
        title={title}
        description={description}
        titleIcon={desktopAppLogoUrl}
        video={getUrlByWidth('banner', 1024)}
        poster={getUrlByWidth('background', 1024)}
        aspectratio={width > 1024 ? dtAspectRatio : mbAspectRatio}
      />
    );
  }
  if (layout === 'Half - Mobile Single CTA') {
    return (
      <HalfSingleCtaBanner
        width={width}
        isDevice={isDevice}
        imageCTA={imageCTA}
        mobileSingleCTA={mobileSingleCTA}
        title={title}
        description={description}
        desktopAppLogo={desktopAppLogoUrl}
        mobileAppLogo={mobileAppLogoUrl}
        video={getUrlByWidth('banner', 1024)}
        poster={getUrlByWidth('background', 1024)}
        aspectratio={width > 1024 ? dtAspectRatio : mbAspectRatio}
      />
    );
  }
  if (layout === 'Full - Mobile Single CTA') {
    return (
      <FullSingleCtaBanner
        width={width}
        isDevice={isDevice}
        imageCTA={imageCTA}
        mobileSingleCTA={mobileSingleCTA}
        title={title}
        content={description}
        desktopAppLogo={desktopAppLogoUrl}
        mobileAppLogo={mobileAppLogoUrl}
        addBannerBorderMb={addBannerBorderMb}
        appList={appList(content)}
        video={getUrlByWidth('banner')}
        poster={getUrlByWidth('background')}
        iconIsSquare={dtIconAspectRatio === 1}
        aspectratio={width > 600 ? dtAspectRatio : mbAspectRatio}
      />
    );
  }
  return (
    <FullBanner
      width={width}
      isDevice={isDevice}
      imageCTA={imageCTA}
      title={title}
      content={description}
      titleIcon={desktopAppLogoUrl}
      addBannerBorderMb={addBannerBorderMb}
      appList={appList(content)}
      video={getUrlByWidth('banner')}
      poster={getUrlByWidth('background')}
      iconIsSquare={dtIconAspectRatio === 1}
      aspectratio={width > 600 ? dtAspectRatio : mbAspectRatio}
    />
  );
}
